<script lang='ts'>
  import moment from 'moment'
  import UIRouterLink from '@shared/svelte/Components/UIRouterLink.svelte';
  import ShareStorefrontModal from '../ShareStorefrontModal.svelte';
  import type { Storefront } from '@shared/types/Storefront';

  export let storefront: Storefront;
  let showShareStorefrontModal = false;

  function formatDate(d: any) {
    // @ts-ignore
    return d === null ? "Unpublished" : "Last published on " + moment(d).format('MMM D, YYYY hh:mm a');
  }

  function closeShareStorefrontModal() {
    showShareStorefrontModal = false;
  }
</script>

<nav class="fizz-subnav fizz-stack-24" data-grid-area="nav" id='nav-storefront-{storefront.id}'>
  <div class="fizz-space-between-responsive">
    <div>
      <p class="fizz-text-medium"><strong>Storefronts</strong></p>
      <h2 class="fizz-heading-2">{storefront.distributor.business_name}</h2>
    </div>
    <div class="fizz-flex-row-8 fizz-hide-on-small">
      <p class="fizz-text-medium fizz-inline-16">{formatDate(storefront.previously_published_at)}</p>
      <UIRouterLink stateName='layout.storefronts_preview' classes='nounderline-hover'
        params={{distributor_id: storefront.distributor_id}}>
        <button class="fizz-button">View</button>
      </UIRouterLink>
      <button class="fizz-button" on:click={() => showShareStorefrontModal = true}>Share</button>
    </div>
    <div class="fizz-hide-on-large">
      <p class="fizz-text-medium fizz-stack-16">{formatDate(storefront.previously_published_at)}</p>
      <div class="fizz-flex-row">
        <UIRouterLink stateName='layout.storefronts_preview'
          params={{distributor_id: storefront.distributor_id}}>
          <button class="fizz-button">View</button>
        </UIRouterLink>
        <button class="fizz-button" on:click={() => showShareStorefrontModal = true}>Share</button>
      </div>
    </div>
  </div>
</nav>

<ShareStorefrontModal {showShareStorefrontModal} {closeShareStorefrontModal} {storefront}></ShareStorefrontModal>
